import { useContext, createContext } from 'react';
// NOTE: The default value for react context is not used in this app.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const DashpageContext = createContext(undefined);
export const useDashpage = () => useContext(DashpageContext);
